<template>
  <div>
    <div class="overflow-hidden rounded-sm bg-white shadow-md w-11/12 lg:w-4/12 m-auto mb-10">
      <div class="p-5 pt-8 text-white bg-header">
        <header>
          <h1 class="text-4xl font-bold">{{pageContent.title}}</h1>
          <h2 class="font-bold">{{ pageContent.subtitle }}</h2>
        </header>
      </div>
      <div class="p-5 py-7">
        <h3 class="text-xl text-gray-600">Login to continue.</h3>
        <main>
          <form @submit.prevent="submitForm">
            <!-- server message -->
            <p class="my-2 animate__animated " :class="serverMessage.err ? ['text-pink-500 animate__headShake'] : ['animate__rubberBand text-green-500'] " v-if="serverMessage.val" v-html="serverMessage.val"></p>

            <!-- username -->
            <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
              <label :for="username.name" class="mr-2 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><circle fill="none" cx="12" cy="7" r="3"></circle><path d="M12 2C9.243 2 7 4.243 7 7s2.243 5 5 5 5-2.243 5-5S14.757 2 12 2zM12 10c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S13.654 10 12 10zM21 21v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h2v-1c0-2.757 2.243-5 5-5h4c2.757 0 5 2.243 5 5v1H21z"></path></svg>
              </label>
              <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="username.name"  :placeholder="username.name" v-model.trim="username.val">
            </div>
            <p class="animate__animated animate__headShake text-left text-pink-500" v-if="username.err">{{username.err}}</p>

            <!-- password -->
            <div class="flex items-center justify-start rounded-md border p-2 mt-2 mb-1 border-gray-500">
              <label :for="password.name" class="mr-2 text-gray-500">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M12,2C9.243,2,7,4.243,7,7v3H6c-1.103,0-2,0.897-2,2v8c0,1.103,0.897,2,2,2h12c1.103,0,2-0.897,2-2v-8c0-1.103-0.897-2-2-2 h-1V7C17,4.243,14.757,2,12,2z M18,12l0.002,8H6v-8H18z M9,10V7c0-1.654,1.346-3,3-3s3,1.346,3,3v3H9z"></path></svg>
              </label>
              <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" :type="password.show ? 'text':'password'" :name="password.name"  :placeholder="password.name" v-model.trim="password.val">
              <button type="button" class="mr-1" @click="password.show = !password.show">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-if="password.show">
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                  <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" v-else>
                  <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                  <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                </svg>
              </button>
            </div>
            <p class="animate__animated animate__headShake text-left text-pink-500" v-if="password.err">{{password.err}}</p>

            <button type="submit" class="overflow-hidden w-full bg-blue-500 hover:bg-blue-600 text-white font-bold rounded-md p-2 mt-2 mb-2">Login</button>
            <router-link class="text-blue-500" to="/forgot-password">Forgot Password?</router-link>
          </form>
        </main>
      </div>
      <div class="p-5">
        <footer>
          <h2 class="text-sm" v-html="pageContent.copyright"></h2>
        </footer>
      </div>
    </div>    
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ref, computed } from 'vue';

export default {
  name: "Login",
  setup() {
    
    // vuex store
    const store = useStore();

    // vue router
    const router = useRouter();

    const pageContent = computed(() => store.getters.pageContent );

    // form
      const serverMessage = ref({
        val:"",
        err: false,
      })

      const username = ref({
        name:"Username",
        val:"",
        err:"",
      });
      const password = ref({
        name:"Password",
        val:"",
        err:"",
        show: false
      });      
      
      function clearForm(){
        username.value.val = "";
        password.value.val = "";
        serverMessage.value.val = "";

        username.value.err = "";
        password.value.err = "";
        serverMessage.value.err = false;
      }

      async function submitForm(){
        const isReset = await resetError(); 
        if(isReset){
          const isValidated = await validateForm();
          if(isValidated){
            const form = {
              username : username.value.val,
              password : password.value.val,
            }
            try {
              const data = await store.dispatch("authModule/loginForm", form);
              clearForm();
              serverMessage.value.val = data.message;
                setTimeout(() => {
                  clearServerMessage();
                  router.replace({ name: "Home" });
              }, 1000);

            } catch (error) {

              if(error.msg){
                serverMessage.value.val = error.msg;
                serverMessage.value.err = true;
                setTimeout(() => {
                  clearServerMessage();
                }, 3000);
              } 

              if(error.errors){
                error.errors.forEach(element => {
                 this[element.param].err = element.msg;
                });
              }
            }
          }
        }
      }

      function clearServerMessage(){
        serverMessage.value.val = "";
        serverMessage.value.err = false;
      }

      function resetError(){
        return new Promise((resolve)=>{
          username.value.err = "";
          password.value.err = "";
          resolve(true);
        })  
      }

       function validateForm(){
        return new Promise((resolve)=>{

          const requireStr = " is required.";

          // username
          if(!username.value.val){
            username.value.err =  username.value.name + requireStr;
          }

          // password
          if(!password.value.val){
            password.value.err =  password.value.name + requireStr;
          }

          resolve(!username.value.err && !password.value.err);

        })  
      }

    return{
      pageContent,
      serverMessage, username, password,
      submitForm, clearForm,
    }
  }
}
</script>

<style lang="scss">

</style>
